import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class Roles_Add extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Save: true,
			Update: true,
			Delete: true,
			View: true,

			Id: 0,

			AllRolesPermissions: [],

			AssignPermissions: [],
		};
	}

	GroupBy(keyGetter) {
		const map = new Map();
		this.state.AllRolesPermissions.forEach((item) => {
			const key = keyGetter(item);
			const collection = map.get(key);
			if (!collection) {
				map.set(key, [item]);
			} else {
				collection.push(item);
			}
		});
		return map;
	}

	AddPermission(PermissionId, allow) {
		let assigned = [];

		const index = this.state.AssignPermissions.findIndex(
			(a) => a === PermissionId
		);

		if (index > -1) {
			assigned.splice(index, 1);
			this.state.AssignPermissions.splice(index, 1);
		} else {
			assigned.push(PermissionId);
		}

		// assigned = assigned.map(p => {
		//     if (p.permissioN_ID === PermissionId) {
		//         return {
		//             permission_id: PermissionId,
		//             is_allow: allow
		//         }
		//     }
		//     else {
		//         return {
		//             permission_id: p.permissioN_ID,
		//             is_allow: false
		//         }
		//     }
		// })
		// console.log(assigned)
		// const index = this.state.AssignPermissions.findIndex(p => p.permission_id === PermissionId)
		// if (index > -1) {
		//     this.state.AssignPermissions.splice(index, 1)
		// } else {
		//     assigned.push({
		//         permission_id: PermissionId,
		//         is_allow: allow
		//     })
		// }

		this.setState((prev) => {
			return {
				...prev,
				AssignPermissions: [...this.state.AssignPermissions, ...assigned],
			};
		});
	}

	render() {
		const grouped = this.GroupBy((p) => p.permissioN_GROUP);

		return (
			<div>
				<MainLayout />
				<div id="right-panel" class="right-panel">
					{/* <Topmenu/>               */}
					<Topmenu PageTitle="Add Role" isShowAddBtn={false} />
					<div class="content">
						<div class="PageHeader_Container">
							<h2>Add Role</h2>
						</div>

						<div class="card">
							<div class="card-body">
								<form novalidate>
									<div class="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label for="">
											<span style={{ color: "red" }}>* </span>Name
										</label>
										<input
											autocomplete="off"
											type="text"
											class="form-control"
											id="RoleName"
											required
										/>
									</div>

									<div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Dashboard
											</button>
											<div class="panel row">
												{grouped.get("Dashboard")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME} </span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Users
											</button>
											<div class="panel row">
												{grouped.get("Users")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Roles
											</button>
											<div class="panel row">
												{grouped.get("Roles")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Geography
											</button>
											<div class="panel row">
												{grouped.get("Geography")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												XpertSite
											</button>
											<div class="panel row">
												{grouped.get("XpertSite")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>
										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												className="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Rider Jobs
											</button>
											<div className="panel row">
												{grouped.get("RiderJobs")?.map((d) => (
													<div
														className="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label className="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span className="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>
										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												className="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												QR Code
											</button>
											<div className="panel row">
												{grouped.get("QRCodes")?.map((d) => (
													<div
														className="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label className="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span className="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												HCFs
											</button>
											<div class="panel row">
												{grouped.get("HCFs")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												BHUsRHCsCluster
											</button>
											<div class="panel row">
												{grouped.get("BHUsRHCsCluster")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Patients
											</button>
											<div class="panel row">
												{grouped.get("Patient")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												className="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Sub Recipient
											</button>
											<div className="panel row">
												{grouped.get("SubRecipient")?.map((d) => (
													<div
														className="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label className="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span className="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												className="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Patient Samples
											</button>
											<div className="panel row">
												{grouped.get("PatientSamples")?.map((d) => (
													<div
														className="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label className="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span className="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Settings
											</button>
											<div class="panel row">
												{grouped.get("Settings")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>

										<div style={{ marginBottom: "10px" }}>
											<button
												type="button"
												class="accordion"
												onClick={(e) => Common.ToggleAccordian(e)}
											>
												Reports
											</button>
											<div class="panel row">
												{grouped.get("Reports")?.map((d) => (
													<div
														class="col-md-6 col-lg-4"
														style={{ marginTop: "10px" }}
													>
														<label class="CheckBox_container Roles_CheckBox">
															<span>{d.permissioN_DISPLAY_NAME}</span>
															<input
																type="checkbox"
																onChange={(e) =>
																	this.AddPermission(
																		d.permissioN_ID,
																		e.target.checked
																	)
																}
																defaultChecked={
																	this.state.Id ? d.permissioN_ALLOWED : false
																}
															/>
															<span class="CheckBox_checkmark"></span>
														</label>
													</div>
												))}
											</div>
										</div>
									</div>

									<div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<button
											type="submit"
											onClick={this.SaveForm}
											id="Form_SaveBtn"
											class="btn btn_style1"
										>
											Save
										</button>
										<Link to="/Roles">
											<button
												type="button"
												id="Form_SaveBtn"
												class="btn btn_style3"
											>
												Cancel
											</button>
										</Link>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}

		var id = Common.GetId();
		if (id !== 0) {
			this.setState({
				Id: id,
			});
			this.SelectRole(id);
		}
		// else
		// {
		//     if(this.props.UserAuthentication.UserInfo?.permissions == "All")
		//     {
		//       this.setState({
		//         Save: false,
		//         Update:false,
		//         Delete:false,
		//         View:false
		//       })
		//     }
		//     else
		//     {
		//       Common.GetUserPermissions(this.props.UserAuthentication.UserInfo?.permissions,"Roles",(lst)=>{
		//         var Id = Common.GetId()
		//         if ( lst.indexOf("View") == -1 || ( Id ==0 && lst.indexOf("Save") == -1) )
		//         {
		//             this.props.history.push("/Dashboard")
		//         }
		//         else
		//         {
		//           for(var i = 0; i < lst.length; i++)
		//           {
		//             this.setState({
		//                 [lst[i]]: false
		//             })
		//           }
		//         }
		//       })
		//     }
		// }
	}

	componentDidMount() {
		$("#RoleName").focus();
		Common.AddClassToMenueLink(
			"MenuLink_Roles",
			true,
			"MenuParentLink_Security"
		);

		var id = Common.GetId();
		if (id !== 0) {
			this.setState(
				{
					Id: id,
				},
				() => {
					this.SelectRole(id);
				}
			);
		}
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						AllRolesPermissions: resp.data,
					});
				}
			}
		);
	}

	SaveForm = (e) => {
		e.preventDefault();
		this.props.ShowLoader({ Isloading: true });
		const assignedPermissions = this.state.AllRolesPermissions.map((p) => {
			if (this.state.AssignPermissions.includes(p.permissioN_ID)) {
				return {
					permissoin_id: p.permissioN_ID,
					is_allow: true,
				};
			} else {
				return {
					permissoin_id: p.permissioN_ID,
					is_allow: false,
				};
			}
		});

		var obj = {
			roleid: this.state.Id,
			rolename: $("#RoleName").val(),
			rolePermissionModels: assignedPermissions,
		};

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			Common.APILinks.Save_Role,
			JSON.stringify(obj),
			(Result) => {
				this.props.ShowLoader({ Isloading: false });
				if (Result.status) {
					this.props.ShowAlert({ Type: 1, Msg: "Saved Successfully" });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);

					if (this.state.Id === 0) this.ResetForm();
					$("#RoleName").focus();
					this.props.history.push("/Roles");
				} else {
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	ResetForm = () => {
		$("#RoleName").val("");
	};
	SelectRole = (id) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.BaseUrlAPI + `/api/roles/RolePermissionById?roleid=${id}`,
			{},
			(resp) => {
				this.props.ShowLoader({ Isloading: false });
				if (resp.status) {
					this.LoadDataInEditMode(resp.data);
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
					if (resp.message === "No record found.") $("#Form_CancelBtn").click();
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(() => {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};

	LoadDataInEditMode = (data) => {
		const assigned = data
			.filter((d) => d.permissioN_ALLOWED)
			.map((a) => a.permissioN_ID);

		this.setState({
			AssignPermissions: assigned,
			AllRolesPermissions: data,
		});
		$("#RoleName").val(data[0]?.rolE_NAME);
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles_Add);
